module.exports = __webpack_public_path__ + "img/image13.f68b44c4.png";